import LoginTab from '@/components/account/LoginV2/log-in-tab';
import ThirdLoginV2 from '@/components/account/ThirdLoginV2';
import { LockFilled } from '@weee-fe/kunlunicon';
import useTranslation from 'next-translate/useTranslation';
import Trans from 'next-translate/Trans';
import { useRouter } from 'next/router';

import { getStoreInfo } from '@/api/item';
import Constants from '@/constants/const';
import { afterUserLoginToOnboarding } from '@/utils/common/pixel';
import { getZipcode } from '@/utils/common/porder';
import { getCookie, setCookieToMemory } from '@/utils/cookie';
import { getSafeRedirectUrl } from '@/utils/safeRedirect';

type LoginWidgetsProps = {
  clickTrack?: (type: string) => void;
  onTabClick?: (tab: any) => void;
  redirect?: string;
};

const LoginWidgets = ({ clickTrack, onTabClick, redirect }: LoginWidgetsProps) => {
  const { t } = useTranslation('common');
  const { lang } = useTranslation('common');
  const router = useRouter();
  const redirectUrl = redirect ? redirect : getSafeRedirectUrl(router.query?.redirect_url as string);

  const handleLoginSuccess = async (value, res) => {
    window.sessionStorage?.removeItem?.('cache-category-list');
    if (lang === Constants.LANGUAGE_EN) {
      let storeInfoResult = await getStoreInfo({ zipcode: getZipcode() });
      if (storeInfoResult?.result) {
        const storeInfo = storeInfoResult?.object || {};
        //有设置store id时, 获取
        setCookieToMemory(Constants.WEEE_STORE, storeInfo.select_store || '');
      }
    }
    await afterUserLoginToOnboarding(res?.next_url, redirectUrl);
    if (getCookie(Constants.REFERRER_ID) && !res?.is_binded) {
      window.location.href = `/${lang}/account/phone-connect?channel_type=phone_verify&redirect_url=${encodeURIComponent(
        redirectUrl
      )}`;
    } else {
      window.location.href = redirectUrl;
    }
  };

  const handleSuccess = (arg1, arg2) => {
    setTimeout(() => {
      handleLoginSuccess(arg1, arg2);
    }, 200);
  };

  return (
    <div className="w-full" id="referral-login-container">
      <ThirdLoginV2
        size="medium"
        clickTrack={clickTrack}
        onThirdLoginSuccess={handleSuccess}
        wechatPopUpSuccessUrl={redirectUrl}
        redirect={redirect}
      />
      <div className="flex items-center justify-center mt-3">
        <span className="flex-1 h-px inline-block bg-surface-300-hairline"></span>
        <span className="relative mx-3 text-surface-500-fg-minor">{t('or')}</span>
        <span className="flex-1 h-px inline-block bg-surface-300-hairline"></span>
      </div>
      <LoginTab
        gap={0}
        contentSelector="#referral-login-container"
        onSuccess={handleSuccess}
        onTabClick={onTabClick}
        redirect={redirect}
        defaultActiveKey={2}
      />
      <div className="mt-2.5 flex items-center justify-center enki-body-2xs-medium text-shade-neutral-base-6">
        <LockFilled fontSize={14} className="mr-1" />
        <span data-testid="wid-login-widgets-security-message">{t('account_security_message')}</span>
      </div>
      <div
        data-testid="wid-login-widgets-terms"
        className="mt-4 px-5 enki-body-2xs-medium text-center text-shade-neutral-base-6">
        <Trans
          i18nKey="ftu:sign_terms"
          components={{
            term: (
              <a
                aria-label="Terms of Service"
                className="text-black"
                tabIndex={-1}
                href={`${process.env.NEXT_PUBLIC_WEB_HOST}/en/about/terms-of-service`}></a>
            ),
            policy: (
              <a
                aria-label="Privacy Policy"
                className="text-black"
                tabIndex={-1}
                href={`${process.env.NEXT_PUBLIC_WEB_HOST}/en/about/privacy-policy`}></a>
            )
          }}
        />
      </div>
    </div>
  );
};

export default LoginWidgets;
